import http from '@/axios/http'
import { getroleId, getroleid, getuser_ctid, getuser_iscustomer, getuser_id } from "@/localStorage/localStorage";

//获取用户列表
export function getUserList(offset, limit, language) {
    const data = {
        user_id: getuser_id(),
        offset: offset,
        limit: limit,
        language: language
    }
    return http({
        url: '/api/user/getUserList',
        method: 'post',
        data
    })
}

//新增用户
export function registerUser({
    username,
    password,
    nickname,
    realname,
    user_email,
    user_sex,
    user_tel,
    user_icon,
    user_qq,
    user_addr,
    user_remarks,
    user_iscustomer,
    roleid,
    user_language
}) {
    const data = {
        username: username,
        password: password,
        nickname: nickname,
        realname: realname,
        user_email: user_email,
        user_sex: user_sex,
        user_tel: user_tel,
        roleid: roleid,
        user_icon: user_icon,
        user_qq: user_qq,
        user_addr: user_addr,
        user_ctid: getuser_ctid(),
        user_iscustomer: user_iscustomer,
        user_remarks: user_remarks,
        user_language
    }
    return http({
        url: '/api/user/registerUser',
        method: 'post',
        data
    })
}

//删除用户
export function deleteUser(user_id, user_iscustomer, user_ctid) {
    const data = {
        user_id: user_id,
        user_iscustomer: user_iscustomer,
        user_ctid: user_ctid
    }
    return http({
        url: '/api/user/deleteUser',
        method: 'post',
        data
    })
}

//修改用户
export function updateUser(user) {
    const data = {
        user_id: user.user_id,
        username: user.username,
        password: user.password,
        user_salt: user.user_salt,
        nickname: user.nickname,
        realname: user.realname,
        // user_email: user.user_email,
        user_sex: user.user_sex,
        user_tel: user.user_tel,
        roleid: user.roleid,
        user_icon: user.user_icon,
        user_qq: user.user_qq,
        user_addr: user.user_addr,
        user_ctid: user.user_ctid,
        user_iscustomer: user.user_iscustomer,
        user_remarks: user.user_remarks,
        user_create: user.user_create,
        user_update: user.user_update,
        user_status: user.user_status,
        user_email: user.user_email,
        roles: user.roles,
        user_language: user.user_language
    }
    return http({
        url: '/api/user/updateUser',
        method: 'post',
        data
    })
}

//获取登录用户能创建的用户权限列表
//获取当前用户可赋予的身份
//权限管理角色列表
export function getFunctionalAuthority(language) {
    const data = {
        user_id: getuser_id(),
        offset: 1,
        limit: 99999,
        language: language
    }
    return http({
        url: '/api/permission/getFunctionalAuthority',
        method: 'post',
        data
    })
}

//修改用户密码
export function changePassword(userId,newpassword) {
    const data ={
                userId:userId,
                newpassword: newpassword
            }
    return http({
        url: '/api/user/changePassword',
        method: 'post',
        data
    })
}

//搜索
export function queryKeyword(keyword, offset = 1, limit = 10, user, language) {
    const data = {
        user_id: getuser_id(),
        keyword: keyword,
        offset: offset,
        limit: limit,
        username: user.username, //用户名(0：正序，1：倒序)
        realname: user.realname, //真实姓名
        cname: user.cname, //归属客户
        iscustomer: user.iscustomer, //用户类型
        tel: user.tel, //手机
        email: user.email, //邮箱
        rolename: user.rolename, //用户角色
        language: language
    }
    return http({
        url: '/api/user/queryKeyword',
        method: 'post',
        data
    })
}

// 设置报警
export function setAlarm(data) {
  return http({
    url: '/api/user/alarm',
    method: 'post',
    data
  })
}
// 设置云监测功能
export function setMonitor(data) {
  return http({
    url: '/api/user/monitor',
    method: 'post',
    data
  })
}